import Header from "./components/Header";
import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import Topic from "./components/Topic";
import ArticleSection from "./components/ArticleSection";
import Readers from "./components/Readers";
import Faq from "./components/Faq";
import About from "./components/About";
import LeakForm from "./components/LeakForm";
import Footer from "./components/Footer";
import JsonLd from "./components/JsonLd";

const sections = [
  {
    id: "diaoxiu",
    en: "SHIFT CONTROVERSY",
    title: "调休争议",
    lead: "每当放假通知公布，'拼出的长假、拆散的周末'便成为热搜常客。我们梳理调休制度的来龙去脉，追问每一次拼假背后的逻辑与代价。",
    icon: "ri-calendar-check-line",
    accent: "primary",
    articles: [
      { tag: "深度解读", title: "调休三十年：从'挪假'到'拼假'，一次长假的经济账", excerpt: "调休制度从何而来？为何越是希望连休，民众抵触越大？我们从政策演变与经济学角度还原调休的来龙去脉。", date: "2026-04-15", reads: "8.4w" },
      { tag: "数据", title: "调研：超六成受访者认为'调休换长假'得不偿失", excerpt: "一份覆盖上万名网民的问卷显示，休息质量与工作节奏成为争议核心。", date: "2026-04-13", reads: "6.2w" },
      { tag: "视角", title: "从春节到五一，为什么我们总在讨论'该不该调休'", excerpt: "当放假安排成为每年固定热搜，我们真正在意的或许是工作与生活边界的重新划定。", date: "2026-04-10", reads: "5.1w" },
    ],
    heroImage: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20calendar%20with%20a%20pencil%20rearranging%20holiday%20dates%20and%20a%20small%20clock%2C%20warm%20cream%20background%20with%20vermilion%20red%20and%20gold%20accents%2C%20minimal%20modern%20documentary%20style%2C%20soft%20shadows&width=900&height=500&seq=mayday-diaoxiu-01&orientation=landscape",
  },
  {
    id: "jiqi",
    en: "HOLIDAY INSIDER",
    title: "假期黑幕",
    lead: "从放假通知的发布节奏，到假期构成的冷知识，揭开那些鲜少被正面讨论的'幕后设定'，帮你看懂每次假期安排的真实逻辑。",
    icon: "ri-scales-3-line",
    accent: "accent",
    reverse: true,
    articles: [
      { tag: "揭秘", title: "五一放假通知为何总在'最后时刻'才发布？", excerpt: "从审批流程到跨部门协调，一张小小的放假安排表背后，藏着怎样的行政链条与谨慎？", date: "2026-04-11", reads: "7.3w" },
      { tag: "盘点", title: "近十年五一假期安排全梳理：哪次调休最'受伤'", excerpt: "我们用一张时间轴，回顾历年五一的放假天数、调休安排与网友真实反应。", date: "2026-04-07", reads: "4.8w" },
      { tag: "常识", title: "法定节假日、公休日与调休，到底有什么区别？", excerpt: "别再把'连休五天'误当法定假日。一文看懂假期构成，保护自己的休息权益。", date: "2026-04-04", reads: "3.9w" },
    ],
    heroImage: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20opened%20document%20folder%20with%20red%20stamp%20and%20official%20notice%20paperwork%2C%20warm%20cream%20and%20amber%20gold%20tones%2C%20documentary%20minimal%20style%2C%20soft%20studio%20lighting&width=900&height=500&seq=mayday-jiqi-01&orientation=landscape",
  },
  {
    id: "jingqu",
    en: "SCENERY TRICKS",
    title: "景区套路",
    lead: "门票之后还有摆渡车、联票与各种'园区外'项目？我们实地走访热门景区，整理出游避坑清单，帮你把钱花在明处。",
    icon: "ri-landscape-line",
    accent: "secondary",
    articles: [
      { tag: "避坑", title: "盘点景区三大隐性收费：摆渡车、联票与'园区外'项目", excerpt: "门票看似便宜，进园却处处要加钱。我们整理出一份隐性收费避坑清单。", date: "2026-04-14", reads: "9.7w" },
      { tag: "实探", title: "实探热门山岳景区：'限流'公告下的黄牛与黑导游", excerpt: "一票难求的背面是另一条灰色产业链，游客又该如何辨别正规渠道与高价陷阱？", date: "2026-04-09", reads: "6.8w" },
      { tag: "攻略", title: "五一错峰出行指南：避开人潮的五个小众思路", excerpt: "反向旅行、错峰时段与冷门选择，教你玩得更从容。", date: "2026-04-05", reads: "5.5w" },
    ],
    heroImage: "https://readdy.ai/api/search-image?query=tourists%20walking%20through%20a%20beautiful%20green%20mountain%20valley%20scenic%20spot%20in%20spring%2C%20olive%20green%20and%20cream%20natural%20tones%2C%20warm%20golden%20afternoon%20light%2C%20cinematic%20editorial%20travel%20photography&width=900&height=500&seq=mayday-jingqu-01&orientation=landscape",
  },
  {
    id: "xiaofei",
    en: "SPENDING TRAPS",
    title: "消费陷阱",
    lead: "低价团的资金流向、节假日涨价的隐秘手法、'舌尖上的优惠'背后的坑——我们拆解节日消费的层层套路，附上实用维权路径。",
    icon: "ri-shopping-bag-3-line",
    accent: "primary",
    reverse: true,
    articles: [
      { tag: "预警", title: "'低价一日游'的购物团，钱到底花在了哪里？", excerpt: "看似划算的价格背后，是强制购物与回扣分成。拆解低价团的资金流向与维权路径。", date: "2026-04-16", reads: "10.2w" },
      { tag: "维权", title: "遇到节假日涨价、捆绑销售，教你三步有效投诉", excerpt: "保留凭证、找准部门、说清诉求——掌握这三点，维权不再是无头苍蝇。", date: "2026-04-12", reads: "7.9w" },
      { tag: "提醒", title: "五一出游注意：这些'舌尖上的优惠'可能是新的坑", excerpt: "景区餐饮、民宿套餐、美食代金券……从细节识别隐藏消费与过期承诺。", date: "2026-04-06", reads: "4.6w" },
    ],
    heroImage: "https://readdy.ai/api/search-image?query=shopping%20bag%20with%20receipts%20and%20price%20tags%20arranged%20on%20warm%20cream%20desk%2C%20vermilion%20red%20and%20soft%20amber%20tones%2C%20flat%20lay%20editorial%20still%20life%2C%20documentary%20minimal%20style&width=900&height=500&seq=mayday-xiaofei-01&orientation=landscape",
  },
];

export default function Home() {
  return (
    <div id="home" className="w-full">
      <JsonLd />
      <TopBar />
      <Header />
      <main>
        <Hero />
        <Topic />
        {sections.map((s) => (
          <ArticleSection key={s.id} {...s} />
        ))}
        <Readers />
        <Faq />
        <About />
        <LeakForm />
      </main>
      <Footer />
    </div>
  );
}